const DEFAULT_EVALUATION_STATUS = 1

export default class EvaluationDetails {
  idEvaluado
  idEvaluador
  idMunicipio
  fechaInicial
  fechaFin
  fechaAplicacion
  institucionSeguridadAspirada
  puestoAspirado
  status
  /** @readonly */
  statusLabel
  observaciones
  /** @readonly */
  evaluado
  /** @readonly */
  evaluador
  /** @readonly */
  municipio

  constructor() {
    this.idEvaluado = null
    this.evaluado = null
    this.idEvaluador = null
    this.evaluador = null
    this.idMunicipio = null
    this.municipio = null
    this.status = DEFAULT_EVALUATION_STATUS
    this.statusLabel = ''

    this.fechaInicial = null
    this.fechaFin = null
    this.fechaAplicacion = null

    this.institucionSeguridadAspirada = ''
    this.puestoAspirado = 'POLICIA'
    this.observaciones = ''
  }

  fromDto(dto) {
    this.idEvaluado = dto.fk_idPersonal
    this.evaluado = dto.Personal || null
    this.idEvaluador = dto.fk_idPersonalEvaluador
    this.evaluador = dto.PersonalEvaluador || null
    this.idMunicipio = dto.fk_idCatMunicipio
    this.municipio = dto.CatMunicipio || null
    this.status = dto.fk_idCatEstatusEvaluacion || DEFAULT_EVALUATION_STATUS
    this.statusLabel = dto.CatEstatusEvaluacion?.title || ''

    this.fechaInicial = dto.fechaInicial
    this.fechaFin = dto.fechaFin
    this.fechaAplicacion = dto.fechaAplicacion

    this.institucionSeguridadAspirada = dto.institucionSeguridadAspira
    this.puestoAspirado = dto.aspiranteAlPuesto
    this.observaciones = dto.observaciones

    return this
  }
}
